// extracted by mini-css-extract-plugin
export default {"invalid-error":"DamageForm_invalid-error__WK8Ev"};